<script setup lang="ts">
  import useHeaderDataLayer from '@/composables/data-layers/useHeaderDataLayer'

  defineProps<{
    item: {
      link: {
        href: string
        text: string
      }
      title: string
    }
  }>()

  const { pushHeaderSpecialAssistanceClickDataLayer } = useHeaderDataLayer()
</script>

<template>
  <NuxtLink
    :to="item.link.href"
    class="flex size-10 items-center justify-center"
    :aria-label="item.title"
    external
    @click="pushHeaderSpecialAssistanceClickDataLayer"
  >
    <Icon name="common/wheelchair" />
  </NuxtLink>
</template>
